/* eslint-disable camelcase */
import { EnvConfigType, AmplifyConfigType } from './ConfigType';
// !!!注意：こちらのファイルを変更すると、本番環境に影響があります。
// prd環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint: 'https://ll2mbpge9k.execute-api.ap-northeast-1.amazonaws.com/prd',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint: 'https://k86tt0x7ig.execute-api.ap-northeast-1.amazonaws.com/prd',
      region: 'ap-northeast-1',
    },
  ],
};

const config: EnvConfigType = {
  env: 'prd',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG', // TODO: エラーログをサーバに送る仕組みができたら、NONEに変更する
  analyticsTrackingId: 'G-553WYP4ECS',
  inquiryFormUrl: 'https://mottosokka.poplar.co.jp/hc/ja/requests/new',
  viewerEndpoint: '',
  lpInquiryFormUrl: 'https://reg18.smp.ne.jp/regist/is?SMPFORM=lhnf-lelepd-a1cf41ba09d27821f084b21488053c2f',
  ymPublishedBibliograpyUrl:
    'https://mottosokka.poplar.co.jp/hc/ja/articles/900005515146-Yomokka-%E6%8E%B2%E8%BC%89%E6%9B%B8%E8%AA%8C%E3%83%AA%E3%82%B9%E3%83%88',
  siteDomain: 'mottosokka.jp',
  adminUrl: 'https://admin.mottosokka.jp',
  yomokkaUrl: 'https://yomokka.mottosokka.jp',
  sagasokkaUrl: 'https://sagasokka.mottosokka.jp',
  mottosokkaUrl: 'https://mottosokka.jp',
  sso: {
    redirectPath: '/loading',
    idpConfig: {
      microsoft: {
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        clientId: 'd565cb4e-8a2b-4273-9f8c-d3ca5c6707a9',
        clientSecret: '', // microsoftでは使用しない
        scope: ['openid', 'profile', 'email', 'User.Read'],
      },
      google: {
        authorizationEndpoint: '', // googleでは使用しない
        clientId: '23062152093-p9i0fhrlpiemfp3t54jakdq76f5kp9au.apps.googleusercontent.com',
        clientSecret: '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',
        scope: ['openid', 'profile', 'email'],
      },
    },
  },
  maintenanceInfoUrl: 'https://mottosokka.jp/maintenance/info.txt',
  maintenanceExpiryUrl: 'https://mottosokka.jp/maintenance/expiry.txt',
};

export default config;
